import React from 'react';
import './style.css';

const QuestionText = ({ text }) => {
  return (
    <p className="question-text">
      {text}
    </p>
  );
};

export default QuestionText;